/* eslint-disable import/first */
import React from 'react';
// import { RiMenuUnfoldLine } from '@react-icons/all-files/ri/RiMenuUnfoldLine';
// eslint:fix RIMenuUnfoldLine is assigned but never used
import { MdCall } from '@react-icons/all-files/md/MdCall';
import { FormattedMessage } from 'react-intl';
import {
  TrackOrder,
  Offers,
  Explore,
  Deals,
  OrderHistory,
  MyFavorites,
  StoreLocations,
} from '../Icons';

import uaeIcon from './images/uae.png';
import bhrIcon from './images/bahrain.png';
import egpIcon from './images/egypt.png';
import kuwaitIcon from './images/kuwait.png';
import omIcon from './images/oman.jpg';
import ksaIcon from './images/ksa.jpg';
import qtrIcon from './images/qatar.png';

export const navList = {
  userAccessMenu: [
    {
      id: 'storeLocator',
      name: <FormattedMessage id="navigation_storeLocator" defaultMessage="Store Locations" />,
      titleId: 'navigation_storeLocator',
      urlLink: '/storelocator',
      icon: StoreLocations,
      state: false,
    },
    {
      id: 'trackOrder',
      name: <FormattedMessage id="navigation_trackOrder" defaultMessage="trackOrder" />,
      // titleId: 'navigation_trackOrder',
      urlLink: '/track-order',
      icon: TrackOrder,
      state: true,
    },
    {
      id: 'greatDeals',
      name: <FormattedMessage id="navigation_greatDeals" defaultMessage="greatDeals" />,
      // titleId: 'navigation_orderHistory',
      urlLink: '/',
      icon: Deals,
      state: false,
    },
    {
      id: 'offers',
      name: <FormattedMessage id="navigation_offers" defaultMessage="offers" />,
      urlLink: '/offers',
      icon: Offers,
      state: true,
    },
    {
      id: 'myFavorites',
      name: <FormattedMessage id="navigation_myFavorites" defaultMessage="My Favorites" />,
      urlLink: '/my-favorites/999',
      icon: MyFavorites,
      state: false,
    },
    {
      id: 'exploreMenu',
      name: <FormattedMessage id="explore_menu" defaultMessage="exploreMenu" />,

      urlLink: '/',
      icon: Explore,
      state: false,
    },
    {
      id: 'orderHistory',
      name: <FormattedMessage id="navigation_orderHistory" defaultMessage="orderHistory" />,
      // titleId: 'navigation_orderHistory',
      urlLink: '/order-history',
      icon: OrderHistory,
      state: true,
    },
  ],
  informationMenu: [
    {
      id: 'feedBack',
      name: <FormattedMessage id="navigation_feedback" defaultMessage="feedback" />,
      urlLink: '/feedback',
      state: true,
    },
    {
      id: 'faq',
      name: <FormattedMessage id="navigation_faq" defaultMessage="faq" />,
      urlLink: '/faq',
      state: false,
    },
    {
      id: 'terms',
      name: <FormattedMessage id="navigation_termsCondition" defaultMessage="termsCondition" />,
      urlLink: '/terms',
      state: false,
    },
    {
      id: 'policy',
      name: <FormattedMessage id="navigation_privacyPolicy" defaultMessage="Privacy Policy" />,
      urlLink: '/privacyPolicy',
      state: false,
    },
    {
      id: 'nutriInfo',
      name: (
        <FormattedMessage
          id="navigation_nutritionInformation"
          defaultMessage="nutritionInformation"
        />
      ),
      state: false,
      urlLink: `/nutritionInfo`,
    },
  ],
  supportMenu: [
    {
      id: 'callSupport',
      name: <FormattedMessage id="navigation_callsupport" defaultMessage="callsupport" />,
      urlLink: '/',
      icon: MdCall,
      state: false,
    },
  ],
};

export const countryList = [
  { name: 'United Arab Emirates', code: 'UAE', flag: uaeIcon },
  { name: 'Bahrain', code: 'BHR', flag: bhrIcon },
  { name: 'Egypt', code: 'EGY', flag: egpIcon },
  { name: 'Kuwait', code: 'KWT', flag: kuwaitIcon },
  { name: 'Oman', code: 'OMN', flag: omIcon },
  { name: 'Jordan', code: 'JON', flag: omIcon },
  { name: 'Qatar', code: 'QAT', flag: qtrIcon },
  { name: 'Saudi Arabia', code: 'KSA', flag: ksaIcon },
];
